const Container = {
  isComponent: el => el.tagName === 'DIV' && el.classList.contains('container'),
  model: {
    defaults: Object.assign({}, {
      name: 'Container',
      tagName: 'div',
      draggable: true,
      droppable: true,
      copyable: true,
      attributes: {
        id: 'container',
        'attr-fluid': false
      },
      traits: [
        {
          name: 'id',
          label: 'ID',
          placeholder: 'ID',
          type: 'text'
        },
        {
          name: 'attr-fluid',
          label: 'Fluid',
          type: 'checkbox'
        }
      ]
    }),
    init() {
      this.on('change:attributes:attr-fluid', this.handleFluidChange)
    },
    handleFluidChange() {
      const targetAttr = this.getAttributes()['attr-fluid']
      if (targetAttr) {
        this.addClass('container--fluid')
      } else {
        this.removeClass('container--fluid')
      }
    }
  }
}

export default Container
